var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "notice-detail" },
    [
      _c("p", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("customer::customers-notice::activity_info"))),
      ]),
      _c(
        "el-form",
        {
          ref: "email",
          staticClass: "edit-form",
          attrs: {
            "hide-required-asterisk": true,
            "label-width": "100px",
            inline: "",
            model: _vm.emailModel,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("customer::customers-notice::avtivity_name"),
                prop: "name",
              },
            },
            [
              _c("el-input", {
                staticStyle: { width: "200px" },
                model: {
                  value: _vm.activityName,
                  callback: function ($$v) {
                    _vm.activityName = $$v
                  },
                  expression: "activityName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("customer::customers-notice::email"),
                prop: "accountId",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: {
                    placeholder: _vm.$t(
                      "customer::customers-notice::please_select"
                    ),
                  },
                  model: {
                    value: _vm.emailModel.accountId,
                    callback: function ($$v) {
                      _vm.$set(_vm.emailModel, "accountId", $$v)
                    },
                    expression: "emailModel.accountId",
                  },
                },
                _vm._l(_vm.emailList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("customer::customers-notice::recipient"),
                prop: "filterValue",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "120px" },
                  attrs: {
                    placeholder: _vm.$t(
                      "customer::customers-notice::please_select"
                    ),
                  },
                  on: { change: _vm.changeReceiverType },
                  model: {
                    value: _vm.emailModel.filter,
                    callback: function ($$v) {
                      _vm.$set(_vm.emailModel, "filter", $$v)
                    },
                    expression: "emailModel.filter",
                  },
                },
                _vm._l(_vm.receiverType, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
              _vm.emailModel.filter !== 0
                ? _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        multiple: _vm.isMultiple,
                        placeholder: _vm.$t(
                          "customer::customers-notice::please_select"
                        ),
                      },
                      model: {
                        value: _vm.emailModel.filterValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.emailModel, "filterValue", $$v)
                        },
                        expression: "emailModel.filterValue",
                      },
                    },
                    _vm._l(_vm.options, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "isDelay" } },
            [
              _c(
                "div",
                {
                  staticStyle: { display: "inline-block" },
                  attrs: { slot: "label" },
                  slot: "label",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("customer::customers-notice::delay_send")) +
                      " "
                  ),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "dark", placement: "bottom" },
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "customer::customers-notice::after_click_info"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c("i", { staticClass: "icon-a-01wenhao iconfont-el" }),
                    ]
                  ),
                ],
                1
              ),
              _c("el-switch", {
                on: { change: _vm.clear },
                model: {
                  value: _vm.emailModel.isDelay,
                  callback: function ($$v) {
                    _vm.$set(_vm.emailModel, "isDelay", $$v)
                  },
                  expression: "emailModel.isDelay",
                },
              }),
              _vm.emailModel.isDelay
                ? _c(
                    "div",
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          "picker-options": _vm.pickerDate,
                          placeholder: _vm.$t(
                            "customer::customers-notice::select_date"
                          ),
                        },
                        model: {
                          value: _vm.emailModel.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.emailModel, "date", $$v)
                          },
                          expression: "emailModel.date",
                        },
                      }),
                      _c("el-time-select", {
                        staticStyle: { width: "160px" },
                        attrs: {
                          disabled: !_vm.emailModel.date,
                          "picker-options": _vm.pickerTime,
                          placeholder: _vm.$t(
                            "customer::customers-notice::select_time"
                          ),
                        },
                        model: {
                          value: _vm.emailModel.time,
                          callback: function ($$v) {
                            _vm.$set(_vm.emailModel, "time", $$v)
                          },
                          expression: "emailModel.time",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%", "margin-left": "-10px" },
              attrs: { prop: "content" },
            },
            [
              _c("p", { staticClass: "title" }, [
                _vm._v(
                  _vm._s(_vm.$t("customer::customers-notice::emial_content"))
                ),
              ]),
              _c("RichEditor", {
                attrs: {
                  placeholder: _vm.$t("customer::customers-notice::content"),
                },
                model: {
                  value: _vm.emailModel.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.emailModel, "content", $$v)
                  },
                  expression: "emailModel.content",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "dialog-footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "info", loading: _vm.saveLoading },
              on: {
                click: function ($event) {
                  return _vm.submitForm(0)
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("customer::customers-notice::in_draft")) +
                  " "
              ),
            ]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
            [_vm._v(_vm._s(_vm.$t("customer::customers-notice::send")))]
          ),
        ],
        1
      ),
      _c("sendDialog", {
        attrs: { emailModel: _vm.sendParams },
        on: {
          save: function ($event) {
            return _vm.$router.go(-1)
          },
        },
        model: {
          value: _vm.isShowSend,
          callback: function ($$v) {
            _vm.isShowSend = $$v
          },
          expression: "isShowSend",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }